import * as angular from 'angular';
let directiveName = 'ngMatch';

function directive($parse: ng.IParseService) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: link
    };

    function link(scope: ng.IScope, element: JQLite, attrs: ng.IAttributes, ctrl: ng.IController) {
        // if ngModel is not defined, we don't need to do anything
        if (!ctrl || !attrs[directiveName]) {
            return;
        }

        var firstPassword = $parse(attrs[directiveName]);

        let validator =  function(value: string) {
            var temp = firstPassword(scope);
            ctrl.$setValidity('match', value === temp);
            return value;
        };

        ctrl.$parsers.unshift(validator);
        ctrl.$formatters.push(validator);

        scope.$watch(attrs[directiveName], function () {
            validator(ctrl.$viewValue);
        });
    }
}

angular
    .module('app.common')
    .directive(directiveName, directive);
directive.$inject = ['$parse'];




// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/directives/ng-match.directive.ts